import React from 'react';

import { INVITE_PROMOTION_PATH } from '@/lib/constants/link';

const OgMetaHead = ({ pathname }: { pathname: string }) => {
  let metaData = ogContent.default;
  if (pathname?.includes('event/share')) {
    metaData = ogContent.shareEvent;
  } else if (pathname === '/capital-gain') {
    metaData = ogContent.capitalGain;
  }
  return (
    <>
      <meta name="title" content={metaData.title} />
      <meta name="description" content={metaData.description} />
      <meta property="og:title" content={metaData.title} />
      <meta property="og:description" content={metaData.description} />
      <meta property="og:type" content={'website'} />
      <meta property="og:url" content={metaData.url} />
      <meta property="og:image" content={metaData.image} />
      <meta property="og:image:width" content={metaData.width} />
      <meta property="og:image:height" content={metaData.height} />
      <meta property="og:image:alt" content={metaData.alt} />
      <meta property="og:site_name" content={metaData.siteName} />
    </>
  );
};

const ogContent = {
  default: {
    title: '비즈넵 환급 - 사업자 정부 환급금, 지금 무료로 확인하세요',
    description: '평균 환급금 906만원, 30초면 확인 가능! 개인사업자, 법인사업자는 물론 폐업자도 꼭 확인해보세요.',
    url: `${process.env.NEXT_PUBLIC_SERVICE_DOMAIN}/home/landing/`,
    image: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/image/img_bznav-refund_og-image.png`,
    width: '1200',
    height: '630',
    alt: '비즈넵 환급 이미지',
    siteName: '비즈넵 환급'
  },
  shareEvent: {
    title: '비즈넵 환급 | 수수료 할인받는 친구초대 이벤트 | 사업자라면 바로 참여 가능',
    description: '친구에게 환급금 조회를 추천해주세요. 사업자는 누구나 참여 가능!',
    url: `${process.env.NEXT_PUBLIC_SERVICE_DOMAIN}${INVITE_PROMOTION_PATH}`,
    image: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/images/home/event/share/og-thumbnail.png`,
    width: '1200',
    height: '600',
    alt: '비즈넵 환급 친구초대 이벤트',
    siteName: '비즈넵 환급'
  },
  capitalGain: {
    title: '양도세 환급금 무료 진단 - 비즈넵 환급',
    description: '1인 평균 150만원 환급, 30초 만에 무료로 진단해드려요! 기본공제 누락부터 특례 적용 여부까지 확인해보세요.',
    url: `${process.env.NEXT_PUBLIC_SERVICE_DOMAIN}/capital-gain`,
    image: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/image/img_bznav-refund-capital-gain_og-image.png`,
    width: '1200',
    height: '630',
    alt: '양도세 환급금 무료 진단 - 비즈넵 환급',
    siteName: '비즈넵 환급'
  }
};

export default OgMetaHead;
